import React, { useState, useRef } from 'react';

import { Table } from '../../../../common/table/Table';
import Modal from '../../../../common/modal/Modal';

import { ClientRelations } from './ClientRelations';

import './ClientsRelationsSearch.css';

export const ClientsRelationsSearch = ({
  context,
  clientRelationInformation,
  setClientRelationInformation,
  clientRelationError,
  setClientRelationError,
  handleClientRelationInformationChange,
  showToaster,
  setSpinnerText,
  setClient,
  fieldsDisabled,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [relation, setRelation] = useState(undefined);

  const discretionList = useRef([
    'Appointment',
    'Study Appointment',
    // eslint-disable-next-line quotes
    "Doctor's Appointment",
    'Aurum',
    'Friend',
    'Other',
  ]);

  const closeModal = () => {
    setClientRelationError({});
    setRelation(undefined);
    setIsModalOpen(false);
  };

  const handleCreateNewButtonClick = () => {
    setClientRelationInformation({
      ...clientRelationInformation,
      relationFirstName: '',
      relationLastName: '',
      relationship: '',
      relationMobile: '',
      relationMobileNumberVerified: false,
      selectedDiscretion: '',
      otherSpecify: '',
      relationEmail: '',
      emailVerified: false,
      isLegalGuardian: false,
      isMainContact: false,
    });

    setRelation(undefined);
    setIsModalOpen(true);
  };

  const handleRowClick = (relation) => {
    let selectedDiscretion;
    let otherSpecify;
    if (discretionList.current.includes(relation.whatToSayWhenWeCall)) {
      selectedDiscretion = relation.whatToSayWhenWeCall;
    } else {
      selectedDiscretion = 'Other';
      otherSpecify = relation.whatToSayWhenWeCall;
    }

    setClientRelationInformation({
      ...clientRelationInformation,
      relationFirstName: relation.firstName,
      relationLastName: relation.lastName,
      relationship: relation.relationship,
      relationMobile: relation.mobile,
      relationMobileNumberVerified: relation.mobileNumberVerified,
      relationEmail: relation.email,
      emailVerified: relation.emailAddressVerified,
      isLegalGuardian: relation.legalGuardian,
      isMainContact: relation.mainContact,
      selectedDiscretion,
      otherSpecify,
    });
    setRelation(relation);
    setIsModalOpen(true);
  };

  const updateSearchResults = (relationsList) => {
    closeModal();
    handleClientRelationInformationChange('searchResults', [...relationsList]);
  };

  return (
    <div className="relations-tab-container">
      <div>
        {clientRelationInformation.searchResults && (
          <Table
            tableData={clientRelationInformation.searchResults}
            hiddenColumns={
              clientRelationInformation.isClientMinor
                ? ['externalReference', 'whatToSayWhenWeCall', 'mobileNumberVerified', 'emailAddressVerified']
                : [
                    'externalReference',
                    'whatToSayWhenWeCall',
                    'mobileNumberVerified',
                    'emailAddressVerified',
                    'legalGuardian',
                  ]
            }
            searchEnabled={true}
            filterEnabled={true}
            onRowClick={handleRowClick}
            tableTitle={'Relations'}
            buttonText={fieldsDisabled ? undefined : 'Add New'}
            onButtonClick={handleCreateNewButtonClick}
            maxRowCount={5}
            horizontalScroll
          />
        )}
      </div>

      {isModalOpen && (
        <Modal
          closeModal={closeModal}
          setIsModalOpen={setIsModalOpen}
          headerTitle={relation ? 'Edit Relation' : 'Add Relation'}
          width={'550px'}
          contentPadding={'2px'}
          justifyContent={'center'}
          hideButton={true}
        >
          <ClientRelations
            relation={relation}
            relations={clientRelationInformation.searchResults}
            discretionList={discretionList}
            context={context}
            setSpinnerText={setSpinnerText}
            showToaster={showToaster}
            closeModal={closeModal}
            updateSearchResults={updateSearchResults}
            clientRelationInformation={clientRelationInformation}
            clientRelationError={clientRelationError}
            setClientRelationError={setClientRelationError}
            handleClientRelationInformationChange={handleClientRelationInformationChange}
            setClient={setClient}
            fieldsDisabled={fieldsDisabled}
          />
        </Modal>
      )}
    </div>
  );
};
